// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataEod_main__4h-C4"};